@if (loanService.application()?.taxReduction) {
  <h3 class="title">Ränteavdrag</h3>
  <p>Ränteavdrag beräknas på samtliga bostadslån och dras av i kalpen som en
    post för alla lån</p>

  <div class="group-holder">
    <div class="subgroup-holder">
      <spb-kalp-item
        format="1.0-0"
        text="Total ränta (kr/mån)"
        [value]="loanService.application()?.taxReduction?.totalInterestMonth"/>
      <spb-kalp-item
        format="1.0-0"
        text="Total ränta (kr/år)"
        [value]="loanService.application()?.taxReduction?.totalInterestYear"/>
      <spb-kalp-item
        format="1.0-0"
        text="Summa ränteavdrag (kr/mån)"
        [value]="loanService.application()?.taxReduction?.taxDeductionMonth"/>
      <spb-kalp-item
        format="1.0-0"
        text="Summa ränteavdrag (kr/år)"
        [value]="loanService.application()?.taxReduction?.taxDeductionYear"/>
      <spb-kalp-item
        format="1.0-0"
        text="Varav över 100 tkr (21%) (kr/mån)"
        [value]="loanService.application()?.taxReduction?.taxDeduction21Month"/>
      <spb-kalp-item
        format="1.0-0"
        text="Varav över 100 tkr (21%) (kr/år)"
        [value]="loanService.application()?.taxReduction?.taxDeduction21Year"/>
    </div>
  </div>
}